import DefaultMapper from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class InvoiceMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/tx/invoices';
	}

	prepareCreate({ params, options, mappedResource }) {
		options.method = 'POST';
		if (params.method) {
			options.url = `${API_BASE_PATH_ADMIN}/wallet/tx/invoices/${params.id}:${params.method}`;
		} else {
			options.url = `${API_BASE_PATH_ADMIN}/wallet/tx/invoices`;
			const data = {
				customType: params.data.customType,
				description: params.data.description,
				invoiceAmount: params.data.invoiceAmount,
				invoiceCurrency: params.data.invoiceCurrency,
				systemAccountId: params.data.systemAccountId,
				vatDefinitionId: params.data.vatDefinitionId,
				walletAccountId: params.id,
			};
			options.body = JSON.stringify(data);
		}
	}
}

export default InvoiceMapper;
